import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { ControlStockService } from './controlstock.service';
import { ControlStockListComponent } from './controlstock-list.component';

@Component({
    selector: 'convfact-controlstockdelete',
    templateUrl: './controlstock-dialog-delete.component.html',
    styleUrls: ['./controlstock.component.css'],
    standalone: false
})

export class ControlStockDialogDeleteComponent {

  uid: string = this.data.uid;
  responseMessage: string;
  error: boolean = false;

  responseReceived: boolean = false;
  requestSent: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ControlStockListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public controlStockService: ControlStockService
  ) { }

  delete() {
    this.requestSent = true;
    this.controlStockService.delete(this.uid)
    .then(message => {
      this.responseMessage = message;
      this.responseReceived = true;
    })
    .catch(err => {
      this.responseMessage = err.error.message;
      this.responseReceived = true;
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
